export enum Icons {
    Label = 'label',
    List = 'list',
    Location = 'location',
    Track = 'track',
    Marketplace = 'marketplace',
    Match = 'match',
    Sync = 'sync'
}